import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

/** Must match AuthService encrypt — prefer env, fall back to legacy key. */
export const TOKEN_ENCRYPTION_KEY =
  process.env.REACT_APP_ENCRYPTION_KEY ||
  'red!!encr!!yption123!!..Trusted??.bizTun';

export const encryptToken = (token) => {
  if (!token) return '';
  return AES.encrypt(token, TOKEN_ENCRYPTION_KEY).toString();
};

export const decryptToken = (encryptedToken) => {
  try {
    const decryptedToken = AES.decrypt(
      encryptedToken,
      TOKEN_ENCRYPTION_KEY
    ).toString(Utf8);
    return decryptedToken || null;
  } catch (error) {
    console.error('Error decrypting token', error);
    return null;
  }
};
